import React from 'react';
import { useFormattedNumberInput } from '@/hooks/useFormattedNumberInput';

export const FormattedNumberInput = React.memo(({
  name,
  value,
  onChange,
  placeholder = '0',
  prefix,
  suffix,
  ariaLabel,
  className = '',
  error = false,
  disabled = false,
  maxLength = undefined,
  max = undefined,
}) => {
  const {
    inputRef,
    formatValue,
    unformatValue,
  } = useFormattedNumberInput();
  const handleInputChange = (e) => {
    disabled ? () => {} : onChange(name, unformatValue(e.target.value));
  };

  return (
    <div className={`flex border items-center justify-center
      ${error ? 'border-red-500 focus:border-red-500' : 'border-gray-300'} rounded-lg`}>
      {prefix && (
        <div className="bg-[#F3F4F8] p-3 border-[#CBCDD6] border rounded-lg rounded-r-none text-base text-[#5B5D6B]">
          {prefix}
        </div>
      )}
      <input
        type="text"
        id={name}
        name={name}
        value={formatValue(value)}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={`w-full p-3 rounded-lg placeholder-[#5B5D6B] ${prefix ? 'rounded-l-none' : ''} ${suffix ? 'rounded-r-none' : ''} ${className}`}
        ref={inputRef}
        aria-label={ariaLabel || name}
        inputMode="decimal"
        disabled={disabled}
        maxLength={maxLength}
        max={max}
      />
      {suffix && (
        <div className="bg-[#F3F4F8] p-3 rounded-lg rounded-l-none text-base text-[#5B5D6B]">
          {suffix}
        </div>
      )}
    </div>
  );
});

FormattedNumberInput.displayName = 'FormattedNumberInput';
